import React from 'react'
import getTCCConfig from 'lib/get-tcc-config'
import { logger } from 'lib/slardar-utils'
import Script from 'next/script'
type TIntercept = string | { method: 'GET' | 'POST'; url: string }
const APIIntercept: React.FC = () => {
  const handleOnload = async () => {
    try {
      const config = await getTCCConfig()
      const intercept = JSON.parse(config.api_intercept || '[]') as TIntercept[]
      const path: Record<'GET' | 'POST', RegExp[]> = {
        GET: [],
        POST: [],
      }
      intercept.forEach((api) => {
        if (typeof api === 'string') {
          path.POST.push(new RegExp(api))
        } else {
          path[api.method].push(new RegExp(api.url))
        }
      })
        ; (window as any)?.secsdk?.csrf?.setProtectedHost?.({
          'www.dongchedi.com': path,
        })
    } catch (error) {
      logger.error(
        `[/motor/api/intercept/convert onError] error message: ${(error as Error).message
        }]`
      )
    }
  }
  return (
    <Script
      src="https://lf3-static.bytednsdoc.com/obj/eden-cn/fapybjlz_lm_zlp/ljhwZthlaukjlkulzlp/security/secsdk.umd.js"
      onLoad={handleOnload}
    />
  )
}

export default APIIntercept
